import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import { Students } from 'types/organization/students';
import i18next from 'i18next';

export class ModuleProgressService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getClassProgressForSelectedModule = async (classId: string, moduleId: string) => {
    const response = await this.axiosInstance.post<Result<Students>>(`/api/classes/${classId}/progress-module-tests`, {
      moduleId,
    });
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(i18next.t('ModuleProgressError', { ns: 'organizationPage' }));
  };
}